<template>
  <div class="tudo">
    <!-- <div class="titulo-fluxos"> MARKUP </div>
    <div class="subtitulo-fluxos"> Confira as informações sobre preços e comissões </div> -->

    <g-titulo-steps
    titulo="MARKUP"
    subtitulo="Confira as informações sobre preços e comissões"
    :imagemEmpresa = imagemEmpresa
    />

    <div
      class="alinhaTexto"
      v-for="(or, indexOramento) in orcamento"
      :key="or.id"
    >
      <div class="emcimadesktop">
        <div class="des-orcamento">ORÇAMENTO: {{or.numeroSolicitacao}}</div>
      </div>
      <div>
        <g-card
          margem="none"
          :flag="true"
          class="margem card-grande motivos-perda"
          largura="100%"
          altura="100%"
          :titulo="'Produto - ' +  (or?.orcamentoProduto?.codigoExterno == null ? ' ' : or?.orcamentoProduto?.codigoExterno + ' - ' ) + or?.orcamentoProduto?.nomeProduto"
          expansivel
          fontSizeTitulo="17px"
          negritoTitulo
          style="border: 1px solid #cdcdcd"
          corCabecalho="#fcb315"
          corTitulo="#4f2c19"
          setaExpansivelMarrom
        >

        <div class="autoriprazopreco">
      <g-button
        class="autoriprazo"
        altura="40px"
        negritoTexto
        tamanhoTexto="11px"
        corTexto="#FFFFFF"
        @click="PopUppPrazo(or)"
        :cor="or.autorizacaoPrazoString ? '#fcb315' : 'white' "
        bordabotao="1px solid"
        corbordabotao= "#4f2c19"
        
      >
      <div class="escritobotao">
        Autoriz. Prazo
      </div>
      </g-button>

      <g-button
        class="autoripreco"
        altura="40px"
        corTexto="#FFFFFF"
        negritoTexto
        @click="PopUppPreco(or)"
        tamanhoTexto="11px"
        :cor="or.autorizacaoPrecoString ? '#fcb315' : 'white' "
        bordabotao="1px solid"
        corbordabotao= "#4f2c19"
      >
      <div class="escritobotao">
        Autoriz. Preço
      </div>
      </g-button>


      <!-- amarelo #fcb315 -->
    </div>

          <div
            class="conteudocard"
            v-for="(componentequantidade, indexOrcamentoQuantidade) in or
              ?.orcamentoProduto?.orcamentoQuantidade"
            :key="componentequantidade.id">

            <div class="quantidadeprodutotudo">
              <p class="titulo-conteudo-fluxos">Quantidade do Produto</p>
              <PInputNumber
                class="quantidadetamanho"
                :min="componentequantidade.quantidadeMin"
                v-model="componentequantidade.quantidade"
              >
              </PInputNumber>
            </div>



            <div class="viaveltudo">
              <div class="viavelbotaoescrito">
                <g-button
                  class="botaoviavel"
                  altura="20px"
                  largura="15px"
                  somenteIcone
                  :sombreado="false"
                  cor="#RRGGBBAA"
                  :icone="componentequantidade.viabilidadeNumero ? 'pi pi-check-circle' : 'pi pi-times-circle'"
                  tamanhoIcone="15px"
                  :corIcone="componentequantidade.viabilidadeNumero ? '#00ff00' : '#FF3333'"
                  @click="PopUpViabilidade(componentequantidade)"
                >
                </g-button>
                <p class="viavelescrito" @click="PopUpViabilidade(componentequantidade)">{{componentequantidade.viabilidadeTexto}}</p>
              </div>
            </div>

            <div class="preco">
              <p class="titulo-conteudo-fluxos">Preço (R$) </p>
              <PInputText
              @focus = focusItensMarkup()
              @focusout = focusItensMarkup()
                @change="
                  CalculaComissao(
                    orcamentoModels[indexOramento].orcamentoProduto.orcamentoQuantidade[indexOrcamentoQuantidade]
                  )
                "
                @keypress="camponumero"
                mode="decimal"
                placeholder="0"
                locale="pt-BR"
                :persistent="true"
                v-model="
                  orcamentoModels[indexOramento].orcamentoProduto
                    .orcamentoQuantidade[indexOrcamentoQuantidade]
                    .valorPrecoReal
                "
                :maxlength="8"
                :minFractionDigits="2"
                :maxFractionDigits="2"
              ></PInputText>
            </div>

            <div class="comissao">
              <p class="titulo-conteudo-fluxos">Comissão (%)</p>
              <div class ="d-flex">
                <PInputText
                :maxlength="4"
                @focus = focusItensMarkup()
                @focusout = focusItensMarkup()
                  @change="
                    CalculaValorReal(
                      orcamentoModels[indexOramento].orcamentoProduto
                        ?.orcamentoQuantidade[indexOrcamentoQuantidade]
                    )
                  "
                  
                  @keypress="camponumero"
                  v-model="
                    orcamentoModels[indexOramento].orcamentoProduto
                      .orcamentoQuantidade[indexOrcamentoQuantidade].comissao
                  "
                  :min="orcamentoModels[indexOramento].orcamentoProduto?.orcamentoQuantidade[indexOrcamentoQuantidade].valorPrecoIdealInferior"
                  :max="orcamentoModels[indexOramento].orcamentoProduto?.orcamentoQuantidade[indexOrcamentoQuantidade].valorPrecoIdealSuperior"
                  :minFractionDigits="2"
                  :maxFractionDigits="2"
                ></PInputText>
                <!-- <g-button 
                  @click="zeraResultado(orcamentoModels[indexOramento].orcamentoProduto
                      .orcamentoQuantidade[indexOrcamentoQuantidade])"
                  class="botao-x"
                  cor="#FFFFFF00"
                  corIcone="#4f2c19"
                  somenteIcone="true"
                  icone="pi pi-times"
                  ></g-button> -->
              </div>
            </div>

            <!-- COMEÇA AQUI -->
            <div class="detalhes">
              <div class="condicaopagamento">
                <p class="titulo-conteudo-fluxos">
                  Condição de pagamento
                </p>
                <p class="subconteudos">{{ formaPagamentoTodos }}</p>
              </div>
              <div class="autorizado">
                <p class="titulo-conteudo-fluxos">
                  Autorizado ({{orcamentoModels[indexOramento].orcamentoProduto?.orcamentoQuantidade[indexOrcamentoQuantidade].porcentagemComissaoEspecialFormatado}}%)
                </p>
              <!-- trazer informação do back -->
                <p class="subconteudos">R$ {{orcamentoModels[indexOramento].orcamentoProduto?.orcamentoQuantidade[indexOrcamentoQuantidade].valorPrecoEspecialFormatado}}</p>
              </div>

              <div class="ideal">
                <p class="titulo-conteudo-fluxos">
                  Ideal (5,00%)
                </p>
                <p class="subconteudos">
                  R$ {{orcamentoModels[indexOramento].orcamentoProduto?.orcamentoQuantidade[indexOrcamentoQuantidade].valorPrecoIdealFormatado}}
                </p>
              </div>

              <!-- aparecer somente se tiver condicao especial -->
              <div v-if="or.dataFimEntregaFormatada != null" class="periodoentrega">
                <p class="titulo-conteudo-fluxos">
                  Período de entrega
                </p>
                <p class="subconteudos">Até {{or.dataFimEntregaFormatada}}</p>
              </div>

              <!-- aparecer somente se tiver condicao especial também -->
              <div v-if="or.negociacaoUnica != null" class="negociacaounica">
                <p class="titulo-conteudo-fluxos">
                  Negociação única?
                </p>
                <p class="subconteudos">
                  {{ or.negociacaoUnica ? "SIM" : "NÃO" }}
                </p>
              </div>

              <PDialog
                :closable="false"
                v-model:visible="popup"
                :breakpoints="{'900px': '70%', '500px': '90%'}"
                :style="{ width: '50%' }"
                :modal="true"
              >
                <div v-if="pt1">
                  <p class="Titulo-PopUp">Observação Geral</p>

                  <PTextArea v-model="objetoObservacaoGeral" rows="5" cols="40" :autoResize="true"></PTextArea>

                  <div class="botoes-popup">
                    <div class="botaoFinalizar">
                      <g-button                      
                        largura="200px"
                        negritoTexto
                        @click="salvandoFrontOBSGERAL"
                      >
                        ADICIONAR
                      </g-button>
                    </div>
  
                    <div class="botaoCancelar">
                      <g-button
                        tipo="cinza"
                        largura="200px"
                        negritoTexto
                        @click="zeraOBSGERAL"
                      >
                        CANCELAR
                      </g-button>
                    </div>
                  </div>
                  
                </div>

                <div v-else-if="pt2">
                  <div class="Titulo-PopUp">
                    <!-- A carta-proposta n° {{ numerocartaproposta }} foi efetivada
                    com sucesso! -->

                  A carta-proposta {{ this.numerocartaproposta }}  foi efetivada com sucesso!
                  </div>

                  <div class="botao-voltar-viabilidade">
                    <g-button
                      largura="200px"
                      negritoTexto
                      @click="paginafinalizada()"
                    >
                      CONTINUAR
                    </g-button>
                  </div>
                </div>

                <div v-else-if="pt3">

                  <div class="viabilidade_total" >

                    <div v-if="this.InfosViabilidade.length > 0">

                      
                      <div class="grid_viabilidade_titulo">
                        
                        <div class="titulo-tabela-Viabilidade">Componente</div>
                        
                        <div class="titulo-tabela-Viabilidade">Linha</div>
                        
                      <div class="titulo-tabela-Viabilidade">Caixas</div>
                      
                      <div class="titulo-tabela-Viabilidade">Folhas</div>
                    
                      <div class="titulo-tabela-Viabilidade">Viabilidade</div>
                      
                    </div>
                                      
                    <hr class="hr_tabela_viabilidade">
                    
                      <div class="grid_viabilidade" v-for="viabilidade in this.InfosViabilidade"
                          :key="viabilidade.id">
                          
                          <div class="text-popUp-Viavel-resultado">
                            {{viabilidade.componenteTipoTexto}}
                          </div>
                          <div class="text-popUp-Viavel-resultado">
                                {{viabilidade.nomeLinha}}
                          </div>
                          <div class="text-popUp-Viavel-resultado">
                                {{viabilidade.quantidadeCaixas}}
                          </div>
                          <div class="text-popUp-Viavel-resultado">
                                {{viabilidade.quantidadeFolhas}}
                          </div>
                          <div class="text-popUp-Viavel-resultado">
                                {{viabilidade.viabilidade ? 'SIM' : 'NÃO' }}
                          </div>
                    
                        </div>

                      </div>

                      <div v-if="this.InfosViabilidade.length == 0" class="titulo-tabela-Viabilidade" >Não há dados para este orçamento!</div>
                  </div>

                  <div class="botao-voltar-viabilidade">
                    <g-button
                      :sombreado="false"
                      largura="200px"
                      negritoTexto
                      @click="
                        pt3 = false;
                        popup = false;
                      "
                    >
                      VOLTAR
                    </g-button>
                  </div>
                </div>

              </PDialog>


              <PDialog
                :closable="false"
                v-model:visible="or.autorizapreco"
                :breakpoints="{'900px': '80%', '500px': '90%'}"
                :style="{ width: '60%' }"
                :modal="true"
              >


                <div class="titulo_lixo_popupautorizacoes">
                      <div class="Titulo-PopUp-autorizacao">Autorização de Preço</div>
    
                    <div class="container-botao-limpar">
                      <g-button
                        class="Botao_Limpar_Autorizacao"
                        tipo="cinza"
                        altura="35px"
                        largura="45px"
                        v-on:acao="LimparAutorizacaoPreco(or)"
                        icone="icone_lixo.svg"
                        tamanhoIcone="15px"
                        somenteIcone
                        :sombreado="false"
                        v-tooltip="'Limpar filtro'"
                      />
                    </div>
                </div>


                  <PTextArea
                    v-model="orcamentoModels[indexOramento].autorizacaoPrecoString"
                    rows="5"
                    cols="40"
                    :autoResize="true"
                  ></PTextArea>

                  <div class="botoes-popup">
                    <div class="botaoCancelar">
                      <g-button
                        tipo="cinza"
                        largura="200px"
                        negritoTexto
                        @click="fechapopupAuthPreco(or)"
                      >
                        VOLTAR
                      </g-button>
                    </div>
                    <div class="botaoFinalizar">
                      <g-button
                        largura="200px"
                        negritoTexto
                        @click="adicionaautorizacaopreco(or)"
                    
                      >
                        SALVAR
                      </g-button>
                    </div>
                  </div>
              </PDialog>


                <PDialog
                :closable="false"
                v-model:visible="or.autorizaprazo"
                :breakpoints="{'900px': '80%', '500px': '90%'}"
                :style="{ width: '60%' }"
                :modal="true"
              >
                  <div class="titulo_lixo_popupautorizacoes">
                    <div class="Titulo-PopUp-autorizacao">Autorização de Prazo</div>
                    <div class="container-botao-limpar">
                      <g-button
                        class="Botao_Limpar_Autorizacao"
                        tipo="cinza"
                        altura="35px"
                        largura="45px"
                        v-on:acao="LimparAutorizacaoPrazo(or)"
                        icone="icone_lixo.svg"
                        tamanhoIcone="15px"
                        somenteIcone
                        :sombreado="false"
                        v-tooltip="'Limpar filtro'"
                      />
                    </div>
                  </div>
                  <PTextArea
                    v-model="orcamentoModels[indexOramento].autorizacaoPrazoString"
                    rows="5"
                    cols="40"
                    :autoResize="true"
                  ></PTextArea>

                  <div class="botoes-popup">
                    <div class="botaoCancelar">
                      <g-button
                        tipo="cinza"
                        largura="200px"
                        negritoTexto
                        @click="fechapopupAuthPrazo(or)"
                      >
                        CANCELAR
                      </g-button>
                    </div>
                    <div class="botaoFinalizar">
                      <g-button
                        largura="200px"
                        negritoTexto
                        @click="adicionarautorizacaoprazo(or)"
                      >
                        SALVAR
                      </g-button>
                    </div>
              </div>




              </PDialog>
            </div>

          </div>
          
          <PDialog :closable="false"
           v-model:visible="popupAviso" 
           :modal="true">

              <p class="Titulo-PopUp">Esta carta possui autorizações em avaliação!</p>

              <div class="botaoFinalizar">
              <g-button
              largura="100%"
              negritoTexto
              tamanhoTexto="15px"
              @click="voltar">
              VOLTAR
              </g-button>
              </div>

          </PDialog>

          <PDialog :closable="false"
           v-model:visible="popupSemPreco" 
           :modal="true">

              <p class="Titulo-PopUp">A carta precisa de no mínimo um Preço por Orcamento!</p>

              <div class="botaoFinalizar">
              <g-button
              largura="100%"
              negritoTexto
              tamanhoTexto="15px"
              @click="voltar">
              VOLTAR
              </g-button>
              </div>

          </PDialog>


          <PDialog :closable="false"
           v-model:visible="popupComissaoZerada" 
           :modal="true">

              <p class="Titulo-PopUp">Conflito de comissão: Markup indica comissão zerada, mas não é um vendedor direto.</p>

              <div class="botaoFinalizar">
              <g-button
              largura="100%"
              negritoTexto
              tamanhoTexto="15px"
              @click="popupComissaoZerada = false">
              VOLTAR
              </g-button>
              </div>

          </PDialog>

            <div class="obervacoes-por-card">
              <div class="frete-orcamento">
                <div class="titulo-conteudo-obs-fluxos" >
                  Frete do Orçamento</div>
                <p class="subconteudos">
                  {{orcamentoModels[indexOramento].tipoFreteOrcamento}}
                </p>
              </div>
              <div class="observacao_negociacao" v-if="or.dataFimEntregaFormatada != null">
                <div class="titulo-conteudo-obs-fluxos" >
                  Observação sobre Condição Especial de Negociação</div>
                <PTextArea v-model="orcamentoModels[indexOramento].observacaoNegociacao" rows="5" cols="50" ></PTextArea>
              </div>
                <div class="observacao_produto">
                  <div class="titulo-conteudo-obs-fluxos">Observação do Produto</div>
                  <PTextArea v-model="orcamentoModels[indexOramento].orcamentoProduto.observacoesProduto" rows="5" cols="50"></PTextArea>
                </div>

                <div class="observacao_produto">
                  <div class="titulo-conteudo-obs-fluxos">Observação sobre o Crédito</div>
                  <PTextArea rows="5" cols="50" v-model="orcamentoModels[indexOramento].observacaoCredito" ></PTextArea>

                </div>
            </div>


              
        </g-card>


      </div>
    </div>


    <div><p class="titulo-conteudo-fluxos">Deseja adicionar observações?</p></div>

        <div class="observacao_geral_fim_da_tela">
          <p class="titulo-fluxos">Observação Geral</p>
          <PTextArea v-model="objetoObservacaoGeral" rows="5" cols="40" :autoResize="true"></PTextArea>
        </div>



    <!-- popup após finalização -->

    <div class="buttons-next-back">
      <div class="button-next">
        <g-button
          tipo="amarelo"
          altura="35px"
          largura="100%"
          negritoTexto 
          @click="SalvarMarkup()"
          :disabled = desabilitaFinalizar
          class="button-continuar"
          >FINALIZAR</g-button>
      </div>
      <div class="button-back">
        <g-button
          tipo="cinza" 
          altura="35px"
          largura="100%"
          negritoTexto 
          @click="VoltarStep2()"
          :class="`button-voltar ${(this.desabilitaBotaoVoltarPagamento) ? 'invisivel' : ''}`"
          >VOLTAR</g-button>
      </div>
    </div>
  </div>
</template>

<script>
import GerarCartaPropostaMarkup from "./GerarCartaPropostaMarkup.js";
export default GerarCartaPropostaMarkup;
</script>

<style scoped>
.titulo-conteudo-obs-fluxos{
  width: 100%;
  color: #3e3e3e;
  text-align: center;
  font-size: 15px;
  font-family: "MontSerrat";
  font-weight: bold;
  margin: 0 0 1px;
  text-overflow: ellipsis;
  white-space: wrap;
  overflow: hidden;
}

.Titulo-PopUp-autorizacao {
  text-align: center;
  justify-self: center;
  align-self: center;
  font-size: 18px;
  font-family: "MontSerrat";
  font-weight: bold;
  color: #3e3e3e;
  opacity: 1;
  margin-bottom: 10px;
  grid-area: 1/1/2/2;
}
.titulo_lixo_popupautorizacoes{
    display: grid;
    grid-template-rows: 1fr;
    grid-template-columns: 1fr;
}
.container-botao-limpar{
  grid-area: 1/2/2/3;
    display: flex;
  justify-self: end;
  align-self: start;
  width: 100%;
  justify-content: end;
}

.botoes_autorizacaoprazo{
  display: flex;
    justify-content: center;
    flex-direction: column-reverse;
    align-items: center;
    gap: 15px
}
.botoes_autorizacaopreco{
  display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
    gap: 15px
}
.hr_tabela_viabilidade{
  width: 750px;
}
.viabilidade_total{
  overflow-x: scroll;
}
  .titulo-tabela-Viabilidade{
  text-align: center;
  font-size: 18px;
  font-family: "MontSerrat";
  font-weight: bold;
  color: #3e3e3e;
  opacity: 1;
}

.text-popUp-Viavel-resultado{
  text-align: center;
  margin-bottom: 5px;
}

.grid_viabilidade {
  display: grid;
  grid-template-columns: repeat(5, 150px);
  grid-template-rows: auto;
  grid-column-gap: 0px;
  grid-row-gap: 30px;
}

.grid_viabilidade_titulo {
  display: grid;
  grid-template-columns: repeat(5, 150px);
  grid-template-rows: auto;
  grid-column-gap: 0px;
  grid-row-gap: 30px;
}


.titulos-text-box_obsgeral{

   font: normal normal 600 18px/31px Montserrat;

}
.obervacoes-por-card{
  display: flex;
  justify-content: center;
  gap: 10px;
  flex-wrap: wrap;
}

.titulos-text-box {
  text-align: center;
  font: normal normal 600 13px/20px Montserrat;
  color: #4d4d4d;
  opacity: 1;
  margin-bottom: 5px;
}
.invisivel{
    visibility: hidden;
}
.linhaviabilidade{
   text-align: center;
}
.componentesviabilidade {
  text-align: center;
}
.escrito-botao-cancelar{
    text-align: center;
  font: normal normal normal 12px/19px Montserrat;
  font-weight: bold;
  letter-spacing: 0px;
  color:#ffff
}
.escritobotao{
  text-align: center;
  font: normal normal normal 12px/19px Montserrat;
  font-weight: bold;
  letter-spacing: 0px;
  color: #4f2c19;
  opacity: 1;
}
.Titulo-PopUp-Viabilidade{
  margin-bottom: 15px;
  text-align: center;
  font: normal normal 600 18px/31px Montserrat;
  color: #4d4d4d;
  opacity: 1;
}
.botao-voltar-viabilidade{
  margin-top: 30px;
  display: flex;
  justify-content: center;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  column-gap: 20px;
  row-gap: 10px;
  align-items: center;
  justify-content: center;
}


.alinhaTexto {
  text-align: center;
  align-items: center;
  justify-content: center;
}
.emcimadesktop {
  margin-bottom: 10px;
}
.quantidadetamanho {
  width: 100%;
}

.margem {
  margin-bottom: 15px;
}
.marginInput {
  margin-top: 17px;
  width: 100px;
}
.botao-x {
width: 50px;
cursor:pointer;
}
.tudo {
  padding: 10px;
}

.autoriprazopreco {
  display: flex;

  gap: 15px;
  justify-content: end;
  flex-wrap: wrap;
}

.autoriprazo {
  width: 100px;
}

.autoripreco {
  width: 100px;
  border: #474646;
}

.quantidadeprodutotudo {
  grid-area: 1 / 1 / 2 / 3;
}
.viaveltudo {
  grid-area: 1 / 3 / 2 / 4;
}
.preco {
  grid-area: 2 / 1 / 3 / 2;
}
.comissao {
  grid-area: 2 / 2 / 3 / 4;
}

.p-inputtext {
  width: 100%;
}

.container-botoes {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.motivos-perda {
  grid-area: motivos-perda;
}

.card-grande {
  width: 100%;
  height: 100%;
}

.text-card-componentes-comissao {
  font: normal normal 600 13px/23px Montserrat;
  color: #5a5a5a;
  text-align: left;
}

.text-card-componentes-preco {
  font: normal normal 600 13px/23px Montserrat;
  color: #5a5a5a;
  text-align: left;
}

.quantidadeproduto {
  font: normal normal 600 13px/23px Montserrat;
  color: #5a5a5a;
  text-align: left;
}

.viavelbotaoescrito {
  display: flex;
}

.botaoviavel {
  margin-left: 10px;
}

.viavelescrito {
  margin-top: 5px;
  font: normal normal 600 15px/23px Montserrat;
  color: #3e3e3e;
  margin-left: 10px;
  text-decoration: underline;
  cursor: pointer;
}

.condicaopagamento {
  font: normal normal 600 13px/23px Montserrat;
  color: #5a5a5a;
}

.subconteudos {
  font: normal normal 500 13px/23px Montserrat;
  color: #8a8a8a;
  margin-top: 5px;
  text-align: left;
}

.text-card-componentes-itens-info-autorizado {
  font: normal normal 600 13px/23px Montserrat;
  color: #5a5a5a;
  margin-bottom: -1%;
  text-align: left;
}

.observacaogeraltudo {
  display: flex;
}

.p-diálogo {
  border-radius: 60%;
}
.Titulo-Inicial {
  text-align: center;
  font: normal normal 600 20px/31px Montserrat;
  color: #4f2c19;
  opacity: 1;
  margin-top: 30px;
}
.Titulo-PopUp {
  text-align: center;
  font: normal normal 600 18px/31px Montserrat;
  color: #4d4d4d;
  opacity: 1;
  margin-bottom: 10px;
}
.Subtitulo-Inicial {
  text-align: center;
  font: normal normal normal 12px/19px Montserrat;
  letter-spacing: 0px;
  color: #8a8a8a;
  opacity: 1;
}
.margim {
  display: flex;
  justify-content: center;
}
.campos-gerar-proposta-select {
  width: 85%;
  height: 35px;
}

.des-orcamento {
  margin-bottom: 10px;
  font: normal normal 600 14px/23px Montserrat;
  color: #4f2c19;
  display: flex;
  justify-content: left;
  text-transform: uppercase;
  opacity: 1;
}

.obs-titulo {
  font: normal normal 500 14px/23px Montserrat;
  color: #797676;
  text-align: left;
  margin-left: 10px;
  margin-top: 15px;
  opacity: 1;
}

.observacaogeral {
  font: normal normal 600 13px/23px Montserrat;
  color: #5a5a5a;
  text-decoration: underline;
  margin-top: 5px;
  text-align: left;
  margin-left: 5px;
}

.obs {
  margin-top: 2%;
  font: normal normal 600 13px/23px Montserrat;
  color: #5a5a5a;
  margin-left: -77px;
  text-decoration: underline;
}

/* .botaoFinalizar {
  margin-bottom: 1%;
} */

.text-finalizar {
  text-align: center;
  font-size: 18px;
  font-family: "MontSerrat";
  font-weight: bold;
  color: #3e3e3e;
  opacity: 1;
  margin-bottom: 28px;
}

.text-popUp-Viavel {
  font: normal normal 600 13px/23px Montserrat;
  color: #474646;
}

.observacoes {
  display: inline;
}

.tabela {
  margin-top: 15px;
  margin-bottom: 5%;
  width: 100%;
  text-align: center;
  overflow: hidden;
  border-collapse: separate;
  border: solid #ccc 1px;
  -webkit-border-radius: 5px;
  -moz-border-radius: 5px;
  border-radius: 5px;
}

table td {
  color: #aaa;
  background-color: white;
  padding: 5px;
  border: 1px solid #ddd;
}

table th {
  font-weight: 600;
  text-align: center;
  font-size: 15px;
  color: rgb(53, 52, 52);
  background-color: white;
  padding: 5px;
  border: 1px solid #ddd;
}

.itens-viabilidade {
  font-weight: 600;
  text-align: center;
  font-size: 15px;
  color: rgb(112, 112, 112);
  background-color: white;
  padding: 5px;
  border: 1px solid #ddd;
}

.conteudoviabilidade {
  display: flex;
  justify-content: space-around;
}

.tabelaviabilidade {
  border: 1px solid #cecece;
  margin-top: 15px;
  margin-bottom: 15px;
}

@media (min-width: 310px) {
}

@media (min-width: 368px) {
}

@media (min-width: 600px) {
  .conteudocard {
    display: grid;
    grid-template-columns: 2fr repeat(2, 1fr);
    grid-template-rows: repeat(2, 1fr);
    grid-column-gap: 10px;
    grid-row-gap: 0px;
  }

  .viaveltudo {
    margin-top: 45px;
    display: flex;
    justify-content: space-evenly;
  }

  .autoriprazopreco {
    display: flex;
  }


  
}

@media (min-width: 801px) {
  .botoes_autorizacaopreco{
  display: flex;
  justify-content: center;
  gap: 15px;
  flex-direction: row-reverse;
}

.botoes_autorizacaoprazo{
  display: flex;
  justify-content: center;
  gap: 15px;
  flex-direction: row-reverse;
}
}

@media (min-width: 1025px) {
  .hr_tabela_viabilidade{
  width: 100%;
  }
  .titulo-tabela-Viabilidade{
  text-align: center;
  font-size: 18px;
  font-family: "MontSerrat";
  font-weight: bold;
  color: #3e3e3e;
  opacity: 1;
}

.text-popUp-Viavel-resultado{
  text-align: center;
  margin-bottom: 5px;
}

.grid_viabilidade {
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  grid-template-rows: auto;
  grid-column-gap: 0px;
  grid-row-gap: 30px;
}

.grid_viabilidade_titulo {
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  grid-template-rows: auto;
  grid-column-gap: 0px;
  grid-row-gap: 30px;
}
  .conteudocard {
    display: grid;
    grid-template-columns: 2fr repeat(2, 1fr) 1.5fr 0.8fr;
    grid-template-rows: 2fr;
    grid-column-gap: 10px;
    grid-row-gap: 0px;
  }

  .quantidadeprodutotudo {
    grid-area: 1 / 1 / 2 / 2;
  }
  .preco {
    grid-area: 1 / 2 / 2 / 3;
  }
  .comissao {
    grid-area: 1 / 3 / 2 / 4;
  }
  .autoriprazopreco {
    grid-area: 1 / 4 / 2 / 5;
    /* justify-content: left;
    justify-self: left; */
    gap: 15px;
    margin-top: 20px;
  }

  .viaveltudo {
    grid-area: 1 / 5 / 2 / 6;
  }

  .observacoes {
    display: flex;
    gap: 15px
  }

  .detalhes {
    grid-area: 2 / 1 / 2 / 6;
    display: flex;
    /* justify-content: space-between; */
    justify-content: space-around;
    margin-top: 15px;
    margin-bottom: 10px;
    margin-bottom: 30px;
  }

  .container-botoes {
    display: flex;
    margin-top: 15px;
    flex-direction: row-reverse;
    align-items: center;
    justify-content: center;
    gap: 15px;
  }
}

@media (min-width: 1281px) {
}
</style>
